module.exports = __webpack_public_path__ + "img/NewWave.aa56cd3a.jpg";